var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "visible": _vm.visible,
      "width": _vm.dialogWidth,
      "top": "8vh",
      "append-to-body": "",
      "close-on-click-modal": false,
      "custom-class": "wording-dialog-custom"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "dialog-header-wrapper",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('span', {
    staticClass: "header-icon"
  }, [_c('i', {
    staticClass: "el-icon-collection"
  })]), _c('span', {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.dialogTitle))])]), _c('div', {
    staticClass: "header-tools"
  }, [_c('div', {
    staticClass: "selected-tag",
    class: {
      'is-active': _vm.selectedIds.length > 0
    }
  }, [_c('span', {
    staticClass: "tag-label"
  }, [_vm._v("Selected")]), _c('span', {
    staticClass: "tag-count"
  }, [_vm._v(_vm._s(_vm.selectedIds.length))])]), _c('el-select', {
    staticClass: "compact-category-select",
    attrs: {
      "placeholder": "All Categories",
      "clearable": "",
      "size": "small"
    },
    on: {
      "change": _vm.fetchData
    },
    model: {
      value: _vm.categoryId,
      callback: function callback($$v) {
        _vm.categoryId = $$v;
      },
      expression: "categoryId"
    }
  }, _vm._l(_vm.categoryList, function (cat) {
    return _c('el-option', {
      key: cat.id,
      attrs: {
        "label": cat.name,
        "value": cat.id
      }
    });
  }), 1), _c('el-input', {
    staticClass: "compact-search-input",
    attrs: {
      "placeholder": "Search wording...",
      "prefix-icon": "el-icon-search",
      "size": "small",
      "clearable": ""
    },
    on: {
      "input": _vm.handleInput,
      "clear": _vm.fetchData
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchData.apply(null, arguments);
      }
    },
    model: {
      value: _vm.keywords,
      callback: function callback($$v) {
        _vm.keywords = $$v;
      },
      expression: "keywords"
    }
  })], 1)]), _c('div', {
    staticClass: "list-sub-toolbar"
  }, [_c('div', {
    staticClass: "tips-text"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _c('span', [_vm._v("Double-click to insert directly, or check items to batch fill.")])]), _vm.normalizedList && _vm.normalizedList.length > 0 ? _c('div', {
    staticClass: "quick-actions"
  }, [_c('el-button', {
    staticClass: "batch-action-btn",
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": _vm.toggleSelectAll
    }
  }, [_vm._v(" " + _vm._s(_vm.isAllSelected ? "Deselect All" : "Select All") + " ")]), _vm.selectedIds.length > 0 ? _c('span', {
    staticClass: "action-divider"
  }, [_vm._v("|")]) : _vm._e(), _vm.selectedIds.length > 0 ? _c('el-button', {
    staticClass: "batch-action-btn clear-btn",
    attrs: {
      "type": "text",
      "size": "mini"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v(" Clear ")]) : _vm._e()], 1) : _vm._e()]), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "wording-scroll-list"
  }, [_vm.normalizedList && _vm.normalizedList.length > 0 ? _vm._l(_vm.normalizedList, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "wording-list-row",
      class: {
        'is-selected': _vm.isSelected(item)
      },
      on: {
        "click": function click($event) {
          return _vm.toggleSelect(item);
        },
        "dblclick": function dblclick($event) {
          $event.stopPropagation();
          return _vm.handleDblClick(item);
        }
      }
    }, [_c('div', {
      staticClass: "row-checkbox",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('el-checkbox', {
      attrs: {
        "value": _vm.isSelected(item)
      },
      on: {
        "change": function change() {
          return _vm.toggleSelect(item);
        }
      }
    })], 1), _c('div', {
      staticClass: "row-content"
    }, [_c('div', {
      staticClass: "item-header-line"
    }, [_c('span', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "dblclick-hint"
    }, [_vm._v("Double click to insert")])]), item.previewText ? _c('div', {
      staticClass: "item-preview"
    }, [_vm._v(" " + _vm._s(item.previewText) + " ")]) : _vm._e()])]);
  }) : !_vm.loading ? _c('div', {
    staticClass: "empty-simple"
  }, [_c('span', [_vm._v("No matching wording")])]) : _vm._e()], 2), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "footer-left-info"
  }, [_c('span', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm.normalizedList.length))]), _vm._v(" items")]), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _c('span', [_vm._v("Selected: "), _c('strong', {
    staticClass: "highlight-count"
  }, [_vm._v(_vm._s(_vm.selectedIds.length))])])]), _c('div', {
    staticClass: "footer-center-lang"
  }, [_c('el-radio-group', {
    staticClass: "lang-radio-group",
    attrs: {
      "size": "mini"
    },
    model: {
      value: _vm.insertLanguage,
      callback: function callback($$v) {
        _vm.insertLanguage = $$v;
      },
      expression: "insertLanguage"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "en"
    }
  }, [_vm._v("En")]), _c('el-radio-button', {
    attrs: {
      "label": "local"
    }
  }, [_vm._v("Local")])], 1)], 1), _c('div', {
    staticClass: "footer-buttons"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-check",
      "disabled": _vm.selectedIds.length === 0
    },
    on: {
      "click": _vm.handleFillIn
    }
  }, [_vm._v(" Fill-in ")])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }